const PIXELING_COEFFICIENT = {
    LEVEL1: 0,
    LEVEL2: 8 / 365,
    LEVEL3: 16 / 365,
    LEVEL4: 24 / 365,
}

export const PIXELATED_LEVEL = [
    PIXELING_COEFFICIENT.LEVEL1,
    PIXELING_COEFFICIENT.LEVEL2,
    PIXELING_COEFFICIENT.LEVEL3,
    PIXELING_COEFFICIENT.LEVEL4,
]

export const VARIANT_INPUT = {
    TRANSPARENT: 'transparent',
    DEFAULT: 'default',
    CORRECT: 'correct',
    INCORRECT: 'incorrect',
}

export const SIZE_INPUT = {
    SMALL: 'small',
    DEFAULT: 'default'
}

export const VARIANT_ICON_BUTTON = {
    INFORMATION: 'information',
    LETTERS: 'letters',
    IMAGE: 'image'
}